import React, { Component } from 'react';
import AppHeader from "./components/AppHeader";
import {isProtectedLocation} from "./lib/NavHelper";
import MessageBus from "./lib/MessageBus";
import {cx} from "./lib/ClassSet";
import WindowContainer from "./components/windows/WindowContainer";
import ContextualMenuContainer from "./components/windows/ContextualMenuContainer";
import './App.scss';

class App extends Component {
  

  UNSAFE_componentWillMount() {
    let self = this;
    this.subscriptions = MessageBus.subscribe("navigation", "goto", (data) => {
      // Not sure why this is necessary, but pushing data.url loses the query
      // string and that's a pain. Just in case, we will add the query string
      // back after testing that the path names are equal
      if (data.url === self.props.router.location.pathname) {
        // Keep query string
        self.props.router.push({
          pathname: data.url,
          query: self.props.router.location.query,
        });
      } else {
        // No change to the code
        self.props.router.push(data.url);
      }
    })

  }

  componentDidMount() {
    this.checkAuthenticated();
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (!nextProps.authenticated && this.props.authenticated) {
      this.props.router.push("/logout");
    } else {
      this.checkAuthenticated();
    }

    if (nextProps.checkoutActive && !this.props.checkoutActive) {
      this.props.router.push("/checkout");
    }
  }

  checkAuthenticated() {
    if (!this.props.authenticated && isProtectedLocation(this.props.router.location)) {
      this.props.loginOrRedirect(this.props.router.location.pathname);
    }
  }

  render() {
    let classes = cx({
      "App": true,
      "checkout": this.props.router.location.pathname.match(/^\/checkout/)
    })

    return (
      <div className={classes}>
        <AppHeader
          authenticated={this.props.authenticated}
          onLogin={this.props.showLogin}
          onLogout={this.props.logout}
          canReadInventory={this.props.canReadInventory}
          canReadShipping={this.props.canReadShipping}
          canReadSales={this.props.canReadSales}
          canReadNotes={this.props.canReadNotes}
          canReadAdmin={this.props.canReadAdmin}
          currentPath={this.props.location.pathname}
        />
        <div className="AppContainer">
          {this.props.children}
        </div>
        <ContextualMenuContainer
          active={this.props.contextualMenu.get("active")}
          items={this.props.contextualMenu.get("items")}
          position={this.props.contextualMenu.get("pos")}
        />
        <WindowContainer
          windows={this.props.windows}
          modals={this.props.modals}
          modalActive={this.props.modalActive}
        />
      </div>
    );
  }
}

export default App;
